import { Dialog, Transition } from '@headlessui/react';
import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import { getAuthorizationHeader, http } from '../../config/http';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { IconAdjustmentsHorizontal, IconX, IconTrash, IconXboxX } from '@tabler/icons-react';
import LoadingIndicator from '../LoadingIndicator';

export default function PindahBarangBanyak({
  setOpenPindahBanyakBarang,
  refreshPage,
  reloadDate,
  openPindahBarangBanyak,
  cabang,
  setSelectedItems,
  selectedItems,
  resetSelectPindahItems,
  closeModalBanyakBarang,
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const ids = selectedItems.map((item) => item.id);
  const [selectCabang, setSelectCabang] = useState([]);
  const [idCabang, setIdCabang] = useState(0);
  const [showConfirm, setShowConfirm] = useState(false);


  useEffect(() => {
    async function getCabangSelect() {
      await http
        .get(`cabang/brankas`, {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setSelectCabang(res.data.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getCabangSelect();
  }, [navigate]);

  const [cabangId, setCabangId] = useState(0);

  async function handleSubmitBrankasToEtalase(e) {
    e.preventDefault();
    setLoading(true);
    const formData = {
      items: ids,
      cabang_id: cabangId
    }
    if (cabangId !== 0) {
      try {
        const response = await http.post('/item/pindah_etalase', formData, {
          headers: { Authorization: getAuthorizationHeader() },
        });
        // console.log(response.data)
        toast.success('Data berhasil dipindah', { autoClose: 600, });
        setOpenPindahBanyakBarang(false);
        setShowConfirm(false);
        setCabangId(0);
        reloadDate();
        setLoading(false);
        resetSelectPindahItems();
        return response.data
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.error('Pilih toko dulu', { autoClose: 600, });
    }
    setLoading(false);
  }
  async function handleSubmitPindahBarang(e) {
    e.preventDefault();
    setLoading(true);
    const formData = {
      cabang_id: idCabang,
      items: ids,
    };
    if (idCabang !== 0) {
      try {
        const response = await http.post('/item/transfer', formData, {
          headers: { Authorization: getAuthorizationHeader() },
        });
        // console.log(response.data)
        toast.success('Data berhasil dipindah', { autoClose: 600, });
        setOpenPindahBanyakBarang(false);
        setIdCabang(0);
        refreshPage();
        setLoading(false);
        return response.data
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.error('Pilih cabang tujuan', { autoClose: 600, });
    }
    setLoading(false);
  }
  function fake() { }
  function removeSelectedItem(itemId) {
    setSelectedItems(currentItems => currentItems.filter(item => item.id !== itemId));
  }
  return (
    <>
      {loading &&
        <LoadingIndicator />
      }
      <Transition appear show={openPindahBarangBanyak} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={fake}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden bg-white dark:bg-slate-900 sm:rounded-xl p-0 text-left align-middle shadow-xl transition-all flex flex-col max-h-[90vh] border dark:border-slate-800">
                  {/* Header */}
                  <div className="px-5 py-3 border-b border-slate-200 dark:border-slate-700/60 bg-white dark:bg-slate-900 flex items-center justify-between sticky top-0 z-10 w-full">
                    <div>
                      <Dialog.Title as="h2" className="text-lg sm:text-xl font-bold text-slate-800 dark:text-slate-100">
                        Pindah ke Etalase / Brankas
                      </Dialog.Title>
                      <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">Memindahkan {ids?.length} barang sekaligus</p>
                    </div>
                      <button
                        onClick={closeModalBanyakBarang}
                        className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 dark:hover:text-slate-300 transition-colors"
                      >
                        <IconX className="w-5 h-5" />
                      </button>
                    </div>

                    {/* Body / Scrollable Content */}
                    <div className="p-5 overflow-y-auto flex-1 bg-slate-50/50 dark:bg-slate-900/50">
                      <div className="bg-white dark:bg-slate-900 border text-center border-slate-200 dark:border-slate-700/60 rounded-lg overflow-hidden shadow-sm">
                        <div className="overflow-x-auto">
                          <table className="w-full text-sm text-left text-slate-600 dark:text-slate-300">
                            <thead className="text-xs text-slate-500 dark:text-slate-400 uppercase bg-slate-50 dark:bg-slate-800/80 border-b border-slate-200 dark:border-slate-700/60">
                              <tr>
                                <th scope="col" className="px-3 py-2 font-semibold w-12 text-center">No</th>
                                <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 align-middle">Kode</th>
                                <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 align-middle">Barang</th>
                                <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 text-right align-middle">Berat</th>
                                <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 text-center w-20">Aksi</th>
                              </tr>
                          </thead>
                          <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                            {selectedItems?.length === 0 ? (
                              <tr>
                                <td colSpan="5" className="px-3 py-6 text-center text-slate-400 dark:text-slate-500">Belum ada barang dipilih</td>
                              </tr>
                            ) : (
                              selectedItems?.map((bt, i) => (
                                <tr key={i} className="hover:bg-amber-50/50 dark:hover:bg-slate-800/50 transition-colors bg-white dark:bg-slate-900">
                                  <td className="px-3 py-1.5 text-center text-slate-400 dark:text-slate-500">{i + 1}</td>
                                  <td className="px-3 py-1.5 font-medium border-l border-slate-200 dark:border-slate-700/60 align-middle text-slate-700 dark:text-slate-300">{bt?.kode_item}</td>
                                  <td className="px-3 py-1.5 border-l border-slate-200 dark:border-slate-700/60 align-middle text-slate-600 dark:text-slate-400 truncate max-w-[150px]">{bt?.jenis_kategori?.nama_jenis}</td>
                                  <td className="px-3 py-1.5 border-l border-slate-200 dark:border-slate-700/60 align-middle text-right tabular-nums text-slate-700 dark:text-slate-300">{bt?.berat} gr</td>
                                  <td className="px-3 py-1.5 border-l border-slate-200 dark:border-slate-700/60 align-middle text-center">
                                    <button
                                      type="button"
                                      onClick={() => removeSelectedItem(bt.id)}
                                      className="inline-flex items-center justify-center w-7 h-7 rounded-lg text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 hover:text-red-600 dark:hover:text-red-400 transition-colors"
                                      title="Batal Pindah"
                                    >
                                      <IconTrash className="w-4 h-4" />
                                    </button>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                    {/* Footer / Actions */}
                    <div className="px-5 py-4 border-t border-slate-200 dark:border-slate-700/60 bg-white dark:bg-slate-900 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sticky bottom-0 w-full z-10">
                      {/* Select Tujuan Pindah - Left */}
                      <div className="relative flex-1 min-w-0">
                        <select
                          value={cabangId || ""}
                          onChange={(e) => setCabangId(e.target.value)}
                          required
                          className="w-full h-10 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 dark:focus:border-amber-500 cursor-pointer appearance-none shadow-sm dark:text-slate-200"
                          style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 8px center' }}
                        >
                          <option value="">Tujuan Pindah...</option>
                          {cabang?.map((cb) => (
                            <option value={cb.id} key={cb.id}>
                              {cb?.nama_cabang}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Action Buttons - Right */}
                      <div className="flex gap-2 flex-shrink-0">
                      <button
                        type="button"
                        disabled={loading}
                        onClick={closeModalBanyakBarang}
                        className="flex-1 sm:flex-none h-10 px-5 inline-flex items-center justify-center gap-2 rounded-lg font-semibold text-slate-700 dark:text-slate-300 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 active:bg-slate-300 transition-colors disabled:opacity-50 text-sm"
                      >
                        Batal
                      </button>
                    <button
                      type="button"
                      disabled={loading || selectedItems?.length === 0 || !cabangId}
                      onClick={() => setShowConfirm(true)}
                      className="flex-[2] sm:flex-none h-10 px-6 inline-flex items-center justify-center gap-2 rounded-lg font-bold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 active:from-amber-600 active:to-amber-700 shadow-md shadow-amber-500/20 transition-all disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:shadow-none disabled:cursor-not-allowed text-sm"
                    >
                      {loading ? (
                        <>
                          <div className="w-5 h-5 rounded-full border-2 border-white/30 border-t-white animate-spin"></div>
                          <span>Memproses...</span>
                        </>
                      ) : (
                        <>
                          <IconAdjustmentsHorizontal className="w-5 h-5" />
                          <span>Pindah Barang</span>
                        </>
                      )}
                    </button>
                      </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      {/* Confirmation Dialog */}
      <Transition appear show={showConfirm} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => !loading && setShowConfirm(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-sm transform overflow-hidden rounded-xl bg-white dark:bg-slate-900 p-6 text-left align-middle shadow-xl transition-all border dark:border-slate-800">
                  <div className="flex items-center justify-center mb-4 w-12 h-12 rounded-full bg-red-100 dark:bg-red-500/20 mx-auto">
                    <IconAdjustmentsHorizontal className="w-6 h-6 text-red-600 dark:text-red-400" />
                  </div>
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-slate-900 dark:text-slate-100 text-center"
                  >
                    Konfirmasi Pemindahan
                  </Dialog.Title>
                  <div className="mt-2 text-center">
                    <p className="text-sm text-slate-500 dark:text-slate-400">
                      Anda yakin akan memindahkan <span className="font-bold text-slate-700 dark:text-slate-300">{ids?.length}</span> barang ini ke tujuan yang dipilih?
                    </p>
                  </div>

                  <div className="mt-6 flex flex-col sm:flex-row gap-3">
                    <button
                      type="button"
                      disabled={loading}
                      className="w-full inline-flex justify-center rounded-xl border border-transparent bg-slate-100 dark:bg-slate-800 px-4 py-2.5 text-sm font-medium text-slate-900 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 focus-visible:ring-offset-2 disabled:opacity-50 transition-colors"
                      onClick={() => setShowConfirm(false)}
                    >
                      Batal
                    </button>
                    <button
                      type="button"
                      disabled={loading}
                      className="w-full inline-flex justify-center rounded-xl border border-transparent bg-red-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 shadow-md shadow-red-500/20 disabled:opacity-50 transition-all"
                      onClick={handleSubmitBrankasToEtalase}
                    >
                      {loading ? (
                        <div className="flex items-center gap-2">
                          <div className="w-4 h-4 rounded-full border-2 border-white/30 border-t-white animate-spin"></div>
                          <span>Proses...</span>
                        </div>
                      ) : (
                        <span>Ya, Pindah</span>
                      )}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
